export class DepartmentSetupModel {
  tblDepartmentId: number = 0;
  parentDepartmentId: number = 0;
  formId: string = "";
  departmentCode: string = "";
  departmentName: string = "";
  email: string = "";
  telephone: string = '';
  clientId: number = 0;
  isActive: boolean = true;
  isDelete: boolean = false;
  isDeactivate: boolean = false;
  createdOnUTC: Date = new Date();
  createdBy: string = "";
  updatedOnUTC: Date = new Date();
  updatedBy: string = "";
  autoGenerateCode: boolean = true;
}

export class DepartmentConfigurationModel {
  formId: string = "";
  formTitle: string = "Department Details";
  addFormName: string = "Add Department";
  editFormName: string = "Edit Department";
  listReportFormName: string = "Saved Department Details";
  addEditInModalPopUp: boolean = true;
  allowAdd: boolean = true;
  selectDepartmentSection: boolean = false;
  allowEdit: boolean = true;
  allowDelete: boolean = true;
  displayListCardView: boolean = false;

  displayDepartmentDropDownList: boolean = false;  //display only department dropdown list
  selectedValueDepartmentDropDownList: any[] = ["0","0"];
  selectedValueServiceDropDownList: number = null;

  displayDepartmentDropdown: boolean = true;
  displayDepartmentDropdown2: boolean = true;
  displayServiceDropdown: boolean = true;

  autoGenerateDepartmentCode: boolean = true;
  requiredFields: RequiredFields = new RequiredFields(); //{ parentDepartment: false, departmentCode: true, departmentName: true, telephone: true, email: false };
  allowedFields: AllowedFields = new AllowedFields(); //{ parentDepartment: false, departmentCode: true, departmentName: true, telephone: true, email: false };
  fieldsTitle: FieldsTitle = new FieldsTitle();
  fieldsFormat: FieldsFormat = new FieldsFormat();
  selectEmployeeSection: boolean = false;
  departmentPanelAddEditRef: any;
}

export class RequiredFields {
  parentDepartment: boolean = false;
  departmentCode: boolean = true;
  departmentName: boolean = true;
  telephone: boolean = true;
  email: boolean = true;
}

export class AllowedFields {
  parentDepartment: boolean = false;
  departmentCode: boolean = true;
  departmentName: boolean = true;
  telephone: boolean = true;
  email: boolean = true;
}

export class DepartmentMappingModel {
  tblDepartmentId: number = 0;
  clientId: number = 0;
  isActive: boolean = true;
  isDelete: boolean = false;
  isDeactivate: boolean = false;
  createdOnUTC: Date = new Date();
  createdBy: string = "";
  updatedOnUTC: Date = new Date();
  updatedBy: string = "";
}

export class ValidationModel {

  isParentDepartmentValid: boolean = true;
  parentDepartmentValidationMessage: string = "Parent department is required";

  isDepartmentCodeValid: boolean = true;
  departmentCodeValidationMessage: string = "Department Code is required";

  isDepartmentNameValid: boolean = true;
  departmentNameValidationMessage: string = "Department Name is required";

  isTelephoneValid: boolean = true;
  telephoneValidationMessage: string = "Telephone is required";

}

export class FieldsTitle {
  telephone1: string = "Telephone 1";
  telephone2: string = "Telephone 2";
}
export class FieldsFormat {
  telephone1: string = "";
  telephone2: string = "";
}
